// extracted by css-extract-rspack-plugin
export default {"statusDot":"CdWwD"};